/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChevronDown from 'DesignSystem/Svgs/Tysiav2ChevronDown/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/Filters/ProvidersAndAssistants/Action"
  
}) {
let tabSelectedSidebarEmployeeResourcesValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.sidebar_employee_resources',
format: fromHelpers.formatPlaceholder,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<div
  data-testid="Action.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="tab.selected.sidebar_employee_resources"
 format="helpers.js formatPlaceholder"
 text={tabSelectedSidebarEmployeeResourcesValueData}
 color={dtColorsNeutral900}
/>
<Tysiav2ChevronDown
  viewPath={`${viewPath}/Tysiav2ChevronDown`}
 marginLeft={dtSpaceMs}
/>
</div>
{children}
</React.Fragment>)
}